import React from "react";
import "./Footer.scss";
// import logo from "../res/heroIMG.png";
// import slash from "../res/icon/slash.svg";
// import discordIco from "../res/icon/discord.svg";
// import githubIco from "../res/icon/github.svg";

export default function Footer() {
  return (
    <footer>
      <div className="wrapper">
        {/* <div className="topbar">
          <img
            className="logo"
            src={logo}
            alt="logo"
            style={{ borderRadius: "12%" }}
          />
          <img className="slash" src={slash} alt="slash" />
          <div>Portfolio</div>
        </div> */}
        <div className="contacts">
          {/* <div className="icon-container">
            <a
              href="https://discord.com/users/742986077228367935"
              rel="noreferrer"
              target="_blank"
              className="icon-link">
              <img src={discordIco} alt="Discord" />
            </a>
            { <div className="popup">
              <div className="popup-content">thedeadstariii</div>
            </div> a}
          </div> */}
          {/* <div className="icon-container">
            <a
              href="https://github.com/DeadstarIII"
              rel="noreferrer"
              target="_blank"
              className="icon-link">
              <img src={githubIco} alt="Github" />
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
}
